import axios from 'axios';

const BASE_URL = process.env.REACT_APP_HELLOTRADE_API_BASE_URL || 'http://localhost:3005/api';

export async function checkConsent(glid, ak) {
  try {
    const params = new URLSearchParams({ glid, ak });
    const response = await axios.get(`${BASE_URL}/v1/check-consent?${params}`, {
      timeout: 8000,
    });
    return response.data;
  } catch (error) {
    console.error('checkConsent failed:', error);
    return null;
  }
}

export async function createConsent({ glid, ak }) {
  try {
    const response = await axios.post(
      `${BASE_URL}/v1/create-consent`,
      { glid, ak },
      { headers: { 'Content-Type': 'application/json' }, timeout: 8000 }
    );
    return response.data;
  } catch (error) {
    console.error('createConsent failed:', error);
    return null;
  }
}
